import { z, isoZ } from 'my-zod'
import { RiderTypeEnum } from './rider-type'

export const riderModel = z.object({
  id: z.string().uuid(),
  shortId: z.string(),
  customerId: z.string().uuid().nullable(),
  guestType: RiderTypeEnum,
  email: z.string().nullable(),
  phone: z.string().nullable(),
  transactionalSMSOptIn: z.boolean(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  rideGroupId: z.string().uuid().nullable(),
  originalReservationId: z.string().uuid().nullable(),
  reservationId: z.string().uuid().nullable(),
  customerWaiverId: z.string().uuid().nullable(),
  referringRiderId: z.string().uuid().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  serverLastModifiedDate: isoZ.instant().nullable(),
  createdDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable(),
  outfitterId: z.number()
})

export type riderModel = z.infer<typeof riderModel>
